import { useState } from "react";
import { motion } from "framer-motion";

export default function EnvelopeLoader() {
  const [gone, setGone] = useState(false);
  if (gone) return null;

  return (
    <motion.div
      data-testid="envelope-loader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden bg-wine text-bone"
      initial={{ y: 0 }}
      animate={{ y: "-100%" }}
      transition={{ delay: 1.7, duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
      onAnimationComplete={() => setGone(true)}
    >
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-0 h-[45%] bg-black/15"
        style={{ clipPath: "polygon(0 0, 100% 0, 50% 100%)" }}
      />
      <motion.div
        className="relative z-10 flex h-28 w-28 items-center justify-center rounded-full border border-bone/40 bg-[#4A1224] shadow-[inset_0_0_36px_rgba(0,0,0,0.5)]"
        initial={{ scale: 0.55, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.34, 1.56, 0.64, 1] }}
      >
        <div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-full border border-bone/25 bg-cream">
          <img
            src="/assets/wmwe-logo-dark.png"
            alt="WMWE — Run to the Table"
            className="h-[92%] w-[92%] object-contain"
          />
        </div>
      </motion.div>
      <motion.p
        className="relative z-10 mt-9 font-sans text-[11px] tracking-[0.45em] text-bone/70"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6, ease: "easeOut" }}
      >
        RECON 2026 // OFFICIAL BRIEFING
      </motion.p>
      <div className="relative z-10 mt-6 h-px w-44 overflow-hidden bg-bone/20">
        <motion.div
          className="h-full bg-bone"
          style={{ transformOrigin: "left" }}
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ delay: 0.45, duration: 1.1, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
}
